import { Reset } from "@bluframe/blublocks"
import styled from "styled-components"

export const Ul = styled(Reset.Ul)`
  display: grid;
  column-gap: 40px;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  row-gap: 20px;
`
